import useSWR from 'swr';

import { type ReadCustomFormFieldsJsonRequest } from '@/apiClient';

import { usePrivate } from '@/components/private';
import { enqueueSnackbar } from '@/providers';

import { useReadCustomFormForEntityIdMessages } from './messages';

export function getReadCustomFormForEntityIdCacheKey(
  request: ReadCustomFormFieldsJsonRequest,
) {
  return `/api/CustomForm/ReadCustomFormForEntity/${request.entityId}/${request.entityType}/${request.editableFormType}/${request.organisationId}`;
}

export interface useReadCustomFormForEntityIdOptions {
  shouldFetch?: boolean;
}

export function useReadCustomFormForEntityId(
  request: ReadCustomFormFieldsJsonRequest | null,
  options?: useReadCustomFormForEntityIdOptions,
) {
  const mergedOptions: useReadCustomFormForEntityIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { customFormApi } = usePrivate();

  const results = useSWR(
    customFormApi && mergedOptions.shouldFetch && request
      ? getReadCustomFormForEntityIdCacheKey(request)
      : null,
    () => customFormApi?.apiCustomFormReadCustomFormForEntityPost(request!),
    {
      onError: (error) => {
        enqueueSnackbar(
          useReadCustomFormForEntityIdMessages[
            'useReadCustomFormForEntityId.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useReadCustomFormForEntityId> error fetching custom form.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !customFormApi;

  return {
    ...results,
    isLoadingOrValidating,
    formResponse: results.data?.data,
  };
}
